module.exports = {
      id: "arrow-down-usage",
      viewBox: "0 0 22.422 26.468",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }